// extracted by mini-css-extract-plugin
export default {"steps":"BC-z","header":"CC-z","description":"DC-z"};